



















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class ListDialog extends Vue implements Components.IEditor {
  @Prop({ default: '' }) public title: string; //タイトル
  @Prop({ default: '' }) public modelName: string;
  // @Prop({ default: ()=> new Array()}) public items: Array<any>;
  @Prop({ default: null }) public captions: Array<string>;
  @Prop({ default: null }) public widths: Array<number>;
  @Prop({ default: false }) public primitive: boolean;
  @Prop({ default: null }) public defaultValue: any;
  /**非同期実行ハンドラを指定すると完了まで待機します。 */
  @Prop({default:null}) public exec: (items:any[])=>Promise<boolean>;
  @Prop({default:true}) public showAdd:boolean;
  @Prop({default:true}) public showRemove:boolean;
  @Prop({ default: null }) public onCreate: (item: any) => Promise<any>;  
  @Prop({default:null}) public width:number;
  @Prop({default:null}) public height:number;
  @Prop({ default: null }) public buttonNames: Array<string>;
  @Prop({default:null}) public execWithIndex: (items:any[], index:number)=>Promise<boolean>;  
  //プリミティブの場合は匿名オブジェクトのvalueプロパティをバインドします。
  @Prop({default:null}) public html: string;
  @Prop({default: false}) public isRemainAfterExec: boolean;

    public activeRow:number = null;
    public activeCol:number = null;
    

    public moveFocus(direction:string){
      var xMove = 0;
      var yMove = 0;
      switch(direction){
        case "left":xMove=-1;break;
        case "right":xMove=1;break;
        case "up":yMove=-1;break;
        case "down":yMove=1;break;
        default : return;
      }

      let currentRow = this.activeRow
      let currentCol = this.activeCol;
      while(currentRow < this.items.length && currentRow >= 0 && currentCol < this.captions.length && currentCol >= 0)
      {
        currentRow += yMove;
        currentCol += xMove;

        var el = document.getElementById(currentRow + '_' + currentCol);
        const controlEl :HTMLElement= el?.querySelector('input');
        if(controlEl) {
          this.activeCol = currentCol;
          this.activeRow = currentRow;
          controlEl.focus();
          break;
        }
      }
    }

    public setActive(row:number,col:number){
      this.activeRow = row;
      this.activeCol = col;
    }

    public isActiveRow(num:number) {
      return num == this.activeRow;
    }
    public isActiveCell(row:number,col:number) {
      return col == this.activeCol && row == this.activeRow;
    }

  public items: Array<any> = new Array();
  public show: boolean = false; //リスト
  public showDialog() {
    this.activeRow = null;
    this.activeCol=null;
    this.listDialog_rowKey = 0;
    if(this.items)this.items.forEach(item => this.setRowKey(item));
    this.maximized = false;
    this.show = true;
  }
  public closeDialog() {
    this.show = false;
    this.$emit('closeDialog');
  }

  /**高さを設定します。 */
  public get gridStyle(): string {
    // return  this.width ? 'width:' + this.width +'px; max-width:unset;':'' ;
    if (this.$api.spMode || this.maximized) return  'max-width:unset;';    
    else return  this.width ? 'width:' + this.width +'px; max-width:unset;':'' ;
  }
  public get gridStyle2(): any {
    //  return (this.height ? 'height:' + this.height + 'px;overflow-y:auto;flex:none;':'') + (this.width ? 'width:' + this.width +'px; max-width:unset;':'' );
    if (this.$api.spMode) return (this.height ? 'height:' + this.height + 'px;overflow-y:auto;flex:none;':'') + 'max-width:unset;';
    else if (this.maximized) return 'max-width:unset;flex:1';
    else return (this.height ? 'height:' + this.height + 'px;overflow-y:auto;flex:none;':'') + (this.width ? 'width:' + this.width +'px; max-width:unset;':'' );
  }    
  public onScroll(event: any) {
    //ヘッダ側の水平スクロールを合わせる
    (this.$refs.listHead as HTMLElement).scrollTo((this.$refs.listView as HTMLElement).scrollLeft, 0);
  }
 @Watch('show')
 public onShowChanged(){
   if(this.show) this.bindIndex+=1;
 }
 public get totalWidth(){
   if (this.widths) {
     var total = 50;
     this.widths.forEach(value => total += value);
     if (this.width && total < this.width -2)total = this.width -2;
     return total + 'px';
   } else {
     return 50 + 'px';
   }
 }
  public bindIndex = 0;
  //IEditor実装
  public validator: Components.Validator = new Components.Validator();
  public controls: Components.IControl[] = new Array();

  public addControl(control: Components.IControl) {
    if (control.validator != null) {
      this.validator.Validators.push(control.validator);
    }
    control.isEdit = true; //編集状態を強制する
    this.controls.push(control);
  }
  public removeControl(control: Components.IControl){
    if (control.validator != null) {
      var index = this.validator.Validators.indexOf(control.validator);
      if (index != -1) this.validator.Validators.splice(index, 1);
    }    
    var index1 = this.controls.indexOf(control);
    if (index1 != -1) this.controls.splice(index1, 1);    
  }
  public onCustomOK(e:any, index:number){
    this.exeIndex = index;
    this.onOk(e);
  }
  exeIndex:number = null;
  // OKボタン
  public onOk(e: any) {
    if(this.captions && this.captions.length > 0 && this.items.length == 0) return;
    //バリデーションを実行する～どうやって?
    e.preventDefault();
    if (this.validator.validate()) {
      //呼び出しもとにイベント処理してもらう
      if (this.primitive) {
        let temp = new Array();
        this.items.forEach(obj => temp.push(obj.value));
        //this.$emit('ok', temp);
        this.onExec(temp);
      } else {
        // this.$emit('ok', this.items);
        this.onExec(this.items);
      }
    // } else {
    //   e.preventDefault();
    }
  }

  public onExec(items:any[]){
    this.$api.startWaitCusor();
    if (this.exec != null){
      //レスポンスが帰ってきたら閉じる

      this.exec(items).then(
        success => {
          this.$api.closeWaitCursor();
          if (this.isRemainAfterExec) this.show = true;
          else this.show = (success || success == undefined) ? false : true;
        }
        );
    } else if (this.execWithIndex != null){
      this.execWithIndex(items,this.exeIndex).then(
        success => {
          this.$api.closeWaitCursor();
          this.show = (success || success == undefined) ? false : true;
        }
        );
    
    } else {
        this.$emit('ok', items);
        this.show = false;      
        this.$api.closeWaitCursor();
    }
    
  }
  
  public listDialog_rowKey:number = 0;
  public setRowKey(item:any){
    item.listDialog_rowKey = 'rowKey_' + this.listDialog_rowKey++;
  }
  //行追加ボタン
  public onAddRow() {
    //配列に新規追加する
    var instance :any = null;
    if (this.primitive) instance = { value: this.defaultValue };
    else instance = this.$api.createInstance(this.modelName);
    this.setRowKey(instance);

    if (this.onCreate) this.onCreate(instance).then((obj)=>this.items.push(obj));
    else this.items.push(instance);

  }

  // 行削除ボタン
  public onRemoveRow(index: number) {
    //これじゃダメな気がするけど
    this.items.splice(index, 1);
  }
  //行追加～外部からの追加
  public onAddItem(item:any){
    this.setRowKey(item);
    this.items.push(item);
  }

  //ダイアログ最大化サポート
  public maximized : boolean = false;
  public onChangeDisplayMode(){
    this.maximized = !this.maximized;
  }
}
